import EditorJS from '@editorjs/editorjs';

import { Notification } from '../../../store/modules/notifications/types';

export enum InstructionEvent {
  SET_PREVENT_ON_CHANGE_EDITOR = 'setPreventOnChangeEditor',
  SUBMIT_DATA = 'submitData',
  ADD_INSTRUCTIONS_TO_DATA = 'addInstructionsToData',
  DESTROY = 'destroy',

  UPDATE_INLINE_ACTION_EVENT_LISTENERS = 'updateInlineActionEventListeners',
  REMOVE_INSTRUCTION_BLOCK = 'removeInstructionBlock',
  CANCEL_INSTRUCTION = 'cancelInstruction',
  NOTIFY = 'notify',
  REMOVE_INSTRUCTION_BLOCK_WITHOUT_SAVING = 'removeInstructionBlockWithoutSaving',

  OPEN_IMAGE_INSTRUCTION_MODAL = 'openImageInstructionModal',
  SAVE_IMAGE_INSTRUCTION = 'saveImageInstruction',
  SAVE_IMAGE_INSTRUCTION_BLOCK = 'saveImageInstructionBlock',
  UPDATE_IMAGE_ACTION_EVENT_LISTENERS = 'updateImageActionEventListeners',
  SET_IMAGE_INSTRUCTION_SELECTION = 'setImageInstructionSelection',

  OPEN_TEXT_INSTRUCTION_MODAL = 'openTextInstructionModal',
  SAVE_TEXT_INSTRUCTION = 'saveTextInstruction',
  SAVE_TEXT_INSTRUCTION_BLOCK = 'saveTextInstructionBlock',
  UPDATE_TEXT_ACTION_EVENT_LISTENERS = 'updateTextActionEventListeners',
  SET_TEXT_INSTRUCTION_SELECTION = 'setTextInstructionSelection',

  OPEN_NOTE_INSTRUCTION_MODAL = 'openNoteInstructionModal',
  SAVE_NOTE_INSTRUCTION = 'saveNoteInstruction',
  SAVE_NOTE_INSTRUCTION_BLOCK = 'saveNoteInstructionBlock',
  UPDATE_NOTE_ACTION_EVENT_LISTENERS = 'updateNoteActionEventListeners',
  SET_NOTE_INSTRUCTION_SELECTION = 'setNoteInstructionSelection',

  OPEN_VIDEO_INSTRUCTION_MODAL = 'openVideoInstructionModal',
  SAVE_VIDEO_INSTRUCTION = 'saveVideoInstruction',
  SAVE_VIDEO_INSTRUCTION_BLOCK = 'saveVideoInstructionBlock',
  UPDATE_VIDEO_ACTION_EVENT_LISTENERS = 'updateVideoActionEventListeners',
  SET_VIDEO_INSTRUCTION_SELECTION = 'setVideoInstructionSelection',

  OPEN_TITLE_INSTRUCTION_MODAL = 'openTitleInstructionModal',
  SAVE_TITLE_INSTRUCTION = 'saveTitleInstruction',
  SAVE_TITLE_INSTRUCTION_BLOCK = 'saveTitleInstructionBlock',
  UPDATE_TITLE_ACTION_EVENT_LISTENERS = 'updateTitleActionEventListeners',
  SET_TITLE_INSTRUCTION_SELECTION = 'setTitleInstructionSelection',

  OPEN_NAME_SCRIPT_INSTRUCTION_MODAL = 'openNameScriptInstructionModal',
  SAVE_NAME_SCRIPT_INSTRUCTION = 'saveNameScriptInstruction',
  SAVE_NAME_SCRIPT_INSTRUCTION_BLOCK = 'saveNameScriptInstructionBlock',
  UPDATE_NAME_SCRIPT_ACTION_EVENT_LISTENERS = 'updateNameScriptActionEventListeners',
  SET_NAME_SCRIPT_INSTRUCTION_SELECTION = 'setNameScriptInstructionSelection',

  OPEN_WEB_PAGE_INSTRUCTION_MODAL = 'openWebPageInstructionModal',
  SAVE_WEB_PAGE_INSTRUCTION = 'saveWebPageInstruction',
  SAVE_WEB_PAGE_INSTRUCTION_BLOCK = 'saveWebPageInstructionBlock',
  UPDATE_WEB_PAGE_ACTION_EVENT_LISTENERS = 'updateWebPageActionEventListeners',
  SET_WEB_PAGE_INSTRUCTION_SELECTION = 'setWebPageInstructionSelection',

  OPEN_DOCUMENT_PAGE_INSTRUCTION_MODAL = 'openDocumentPageInstructionModal',
  SAVE_DOCUMENT_PAGE_INSTRUCTION = 'saveDocumentPageInstruction',
  SAVE_DOCUMENT_PAGE_INSTRUCTION_BLOCK = 'saveDocumentPageInstructionBlock',
  UPDATE_DOCUMENT_PAGE_ACTION_EVENT_LISTENERS = 'updateDocumentPageActionEventListeners',
  SET_DOCUMENT_PAGE_INSTRUCTION_SELECTION = 'setDocumentPageInstructionSelection',

  OPEN_AUDIO_INSTRUCTION_MODAL = 'openAudioInstructionModal',
  SAVE_AUDIO_INSTRUCTION = 'saveAudioInstruction',
  SAVE_AUDIO_INSTRUCTION_BLOCK = 'saveAudioInstructionBlock',
  UPDATE_AUDIO_ACTION_EVENT_LISTENERS = 'updateAudioActionEventListeners',
  SET_AUDIO_INSTRUCTION_SELECTION = 'setAudioInstructionSelection',
}

export enum InstructionCSSClasses {
  INLINE_INSTRUCTION_ACTION = 'inline-instruction',
  BLOCK_INSTRUCTION_ACTION = 'block-instruction',
  INLINE_INSTRUCTION_CONTENT = 'inline-instruction-content',
  BLOCK_INSTRUCTION_CONTENT = 'block-instruction-content',
  INLINE_INSTRUCTION_WRAPPER = 'inline-instruction-wrapper',
  BLOCK_INSTRUCTION_WRAPPER = 'block-instruction-wrapper',

  INSTRUCTION_TOOLTIP = 'instruction-tooltip',

  IMAGE_INSTRUCTION_WRAPPER = 'image-instruction',
  IMAGE_INSTRUCTION_ACTION = 'image-instruction-action',
  IMAGE_INSTRUCTION_CONTENT = 'image-instruction-content',
  IMAGE_INSTRUCTION_BLOCK = 'image-instruction-block',
  IMAGE_INSTRUCTION_BLOCK_ACTION = 'image-instruction-block-action',
  IMAGE_INSTRUCTION_BLOCK_CONTENT = 'image-instruction-block-content',

  TEXT_INSTRUCTION_WRAPPER = 'text-instruction',
  TEXT_INSTRUCTION_ACTION = 'text-instruction-action',
  TEXT_INSTRUCTION_CONTENT = 'text-instruction-content',
  TEXT_INSTRUCTION_BLOCK = 'text-instruction-block',
  TEXT_INSTRUCTION_BLOCK_ACTION = 'text-instruction-block-action',
  TEXT_INSTRUCTION_BLOCK_CONTENT = 'text-instruction-block-content',

  NOTE_INSTRUCTION_WRAPPER = 'note-instruction',
  NOTE_INSTRUCTION_ACTION = 'note-instruction-action',
  NOTE_INSTRUCTION_CONTENT = 'note-instruction-content',
  NOTE_INSTRUCTION_BLOCK = 'note-instruction-block',
  NOTE_INSTRUCTION_BLOCK_ACTION = 'note-instruction-block-action',
  NOTE_INSTRUCTION_BLOCK_CONTENT = 'note-instruction-block-content',

  VIDEO_INSTRUCTION_WRAPPER = 'video-instruction',
  VIDEO_INSTRUCTION_ACTION = 'video-instruction-action',
  VIDEO_INSTRUCTION_CONTENT = 'video-instruction-content',
  VIDEO_INSTRUCTION_BLOCK = 'video-instruction-block',
  VIDEO_INSTRUCTION_BLOCK_ACTION = 'video-instruction-block-action',
  VIDEO_INSTRUCTION_BLOCK_CONTENT = 'video-instruction-block-content',

  TITLE_INSTRUCTION_WRAPPER = 'title-instruction',
  TITLE_INSTRUCTION_ACTION = 'title-instruction-action',
  TITLE_INSTRUCTION_CONTENT = 'title-instruction-content',
  TITLE_INSTRUCTION_BLOCK = 'title-instruction-block',
  TITLE_INSTRUCTION_BLOCK_ACTION = 'title-instruction-block-action',
  TITLE_INSTRUCTION_BLOCK_CONTENT = 'title-instruction-block-content',

  NAME_SCRIPT_INSTRUCTION_WRAPPER = 'name-script-instruction',
  NAME_SCRIPT_INSTRUCTION_ACTION = 'name-script-instruction-action',
  NAME_SCRIPT_INSTRUCTION_CONTENT = 'name-script-instruction-content',
  NAME_SCRIPT_INSTRUCTION_BLOCK = 'name-script-instruction-block',
  NAME_SCRIPT_INSTRUCTION_BLOCK_ACTION = 'name-script-instruction-block-action',
  NAME_SCRIPT_INSTRUCTION_BLOCK_CONTENT = 'name-script-instruction-block-content',

  WEB_PAGE_INSTRUCTION_WRAPPER = 'web-page-instruction',
  WEB_PAGE_INSTRUCTION_ACTION = 'web-page-instruction-action',
  WEB_PAGE_INSTRUCTION_CONTENT = 'web-page-instruction-content',
  WEB_PAGE_INSTRUCTION_BLOCK = 'web-page-instruction-block',
  WEB_PAGE_INSTRUCTION_BLOCK_ACTION = 'web-page-instruction-block-action',
  WEB_PAGE_INSTRUCTION_BLOCK_CONTENT = 'web-page-instruction-block-content',

  DOCUMENT_PAGE_INSTRUCTION_WRAPPER = 'document-page-instruction',
  DOCUMENT_PAGE_INSTRUCTION_ACTION = 'document-page-instruction-action',
  DOCUMENT_PAGE_INSTRUCTION_CONTENT = 'document-page-instruction-content',
  DOCUMENT_PAGE_INSTRUCTION_BLOCK = 'document-page-instruction-block',
  DOCUMENT_PAGE_INSTRUCTION_BLOCK_ACTION = 'document-page-instruction-block-action',
  DOCUMENT_PAGE_INSTRUCTION_BLOCK_CONTENT = 'document-page-instruction-block-content',

  AUDIO_INSTRUCTION_WRAPPER = 'audio-instruction',
  AUDIO_INSTRUCTION_ACTION = 'audio-instruction-action',
  AUDIO_INSTRUCTION_CONTENT = 'audio-instruction-content',
  AUDIO_INSTRUCTION_BLOCK = 'audio-instruction-block',
  AUDIO_INSTRUCTION_BLOCK_ACTION = 'audio-instruction-block-action',
  AUDIO_INSTRUCTION_BLOCK_CONTENT = 'audio-instruction-block-content',
}

export type BaseSaveInstructionData = {
  instructionId: string;
  tooltip?: string;
  data?: string;
};

export type BaseOpenInstructionModal = {
  instructionId: string;
  isInline: boolean;
};

export type OpenTextInstructionModal = BaseOpenInstructionModal & {
  text: string;
};

export type BaseSaveInstructionDataBlock = BaseSaveInstructionData & {
  text: string;
};

type UpdateActionEventListeners = {
  instanceEditor: EditorJS;
  refEditor: HTMLDivElement;
};

export interface InstructionEventCallbackData {
  [InstructionEvent.SET_PREVENT_ON_CHANGE_EDITOR]: boolean;
  [InstructionEvent.DESTROY]: {};
  [InstructionEvent.SUBMIT_DATA]: {};
  [InstructionEvent.REMOVE_INSTRUCTION_BLOCK]: {};
  [InstructionEvent.CANCEL_INSTRUCTION]: {};
  [InstructionEvent.ADD_INSTRUCTIONS_TO_DATA]: any[];
  [InstructionEvent.UPDATE_INLINE_ACTION_EVENT_LISTENERS]: {};
  [InstructionEvent.NOTIFY]: Notification;
  [InstructionEvent.REMOVE_INSTRUCTION_BLOCK_WITHOUT_SAVING]: {};

  [InstructionEvent.OPEN_IMAGE_INSTRUCTION_MODAL]: BaseOpenInstructionModal;
  [InstructionEvent.SAVE_IMAGE_INSTRUCTION]: BaseSaveInstructionData;
  [InstructionEvent.SAVE_IMAGE_INSTRUCTION_BLOCK]: BaseSaveInstructionDataBlock;
  [InstructionEvent.UPDATE_IMAGE_ACTION_EVENT_LISTENERS]: UpdateActionEventListeners;
  [InstructionEvent.SET_IMAGE_INSTRUCTION_SELECTION]: {};

  [InstructionEvent.OPEN_TEXT_INSTRUCTION_MODAL]: OpenTextInstructionModal;
  [InstructionEvent.SAVE_TEXT_INSTRUCTION]: BaseSaveInstructionData;
  [InstructionEvent.SAVE_TEXT_INSTRUCTION_BLOCK]: BaseSaveInstructionDataBlock;
  [InstructionEvent.UPDATE_TEXT_ACTION_EVENT_LISTENERS]: UpdateActionEventListeners;
  [InstructionEvent.SET_TEXT_INSTRUCTION_SELECTION]: {};

  [InstructionEvent.OPEN_NOTE_INSTRUCTION_MODAL]: BaseOpenInstructionModal;
  [InstructionEvent.SAVE_NOTE_INSTRUCTION]: BaseSaveInstructionData;
  [InstructionEvent.SAVE_NOTE_INSTRUCTION_BLOCK]: BaseSaveInstructionDataBlock;
  [InstructionEvent.UPDATE_NOTE_ACTION_EVENT_LISTENERS]: UpdateActionEventListeners;
  [InstructionEvent.SET_NOTE_INSTRUCTION_SELECTION]: {};

  [InstructionEvent.OPEN_VIDEO_INSTRUCTION_MODAL]: BaseOpenInstructionModal;
  [InstructionEvent.SAVE_VIDEO_INSTRUCTION]: BaseSaveInstructionData;
  [InstructionEvent.SAVE_VIDEO_INSTRUCTION_BLOCK]: BaseSaveInstructionDataBlock;
  [InstructionEvent.UPDATE_VIDEO_ACTION_EVENT_LISTENERS]: UpdateActionEventListeners;
  [InstructionEvent.SET_VIDEO_INSTRUCTION_SELECTION]: {};

  [InstructionEvent.OPEN_TITLE_INSTRUCTION_MODAL]: BaseOpenInstructionModal;
  [InstructionEvent.SAVE_TITLE_INSTRUCTION]: BaseSaveInstructionData;
  [InstructionEvent.SAVE_TITLE_INSTRUCTION_BLOCK]: BaseSaveInstructionDataBlock;
  [InstructionEvent.UPDATE_TITLE_ACTION_EVENT_LISTENERS]: UpdateActionEventListeners;
  [InstructionEvent.SET_TITLE_INSTRUCTION_SELECTION]: {};

  [InstructionEvent.OPEN_NAME_SCRIPT_INSTRUCTION_MODAL]: BaseOpenInstructionModal;
  [InstructionEvent.SAVE_NAME_SCRIPT_INSTRUCTION]: BaseSaveInstructionData;
  [InstructionEvent.SAVE_NAME_SCRIPT_INSTRUCTION_BLOCK]: BaseSaveInstructionDataBlock;
  [InstructionEvent.UPDATE_NAME_SCRIPT_ACTION_EVENT_LISTENERS]: UpdateActionEventListeners;
  [InstructionEvent.SET_NAME_SCRIPT_INSTRUCTION_SELECTION]: {};

  [InstructionEvent.OPEN_WEB_PAGE_INSTRUCTION_MODAL]: BaseOpenInstructionModal;
  [InstructionEvent.SAVE_WEB_PAGE_INSTRUCTION]: BaseSaveInstructionData;
  [InstructionEvent.SAVE_WEB_PAGE_INSTRUCTION_BLOCK]: BaseSaveInstructionDataBlock;
  [InstructionEvent.UPDATE_WEB_PAGE_ACTION_EVENT_LISTENERS]: UpdateActionEventListeners;
  [InstructionEvent.SET_WEB_PAGE_INSTRUCTION_SELECTION]: {};

  [InstructionEvent.OPEN_DOCUMENT_PAGE_INSTRUCTION_MODAL]: BaseOpenInstructionModal;
  [InstructionEvent.SAVE_DOCUMENT_PAGE_INSTRUCTION]: BaseSaveInstructionData;
  [InstructionEvent.SAVE_DOCUMENT_PAGE_INSTRUCTION_BLOCK]: BaseSaveInstructionDataBlock;
  [InstructionEvent.UPDATE_DOCUMENT_PAGE_ACTION_EVENT_LISTENERS]: UpdateActionEventListeners;
  [InstructionEvent.SET_DOCUMENT_PAGE_INSTRUCTION_SELECTION]: {};

  [InstructionEvent.OPEN_AUDIO_INSTRUCTION_MODAL]: BaseOpenInstructionModal;
  [InstructionEvent.SAVE_AUDIO_INSTRUCTION]: BaseSaveInstructionData;
  [InstructionEvent.SAVE_AUDIO_INSTRUCTION_BLOCK]: BaseSaveInstructionDataBlock;
  [InstructionEvent.UPDATE_AUDIO_ACTION_EVENT_LISTENERS]: UpdateActionEventListeners;
  [InstructionEvent.SET_AUDIO_INSTRUCTION_SELECTION]: {};
}

export const InstructionAttribute = {
  instructionId: 'instruction-id',
  tooltip: 'data-tooltip',
  data: 'data-instruction',
};

export const InstructionActionTooltip = {
  note: 'Editor note',
  text: 'Text overlay',
  image: 'Image',
  video: 'Video',
  title: 'Title',
  nameScript: 'Name in script',
  webPage: 'Web page',
  documentPage: 'Document page',
  audio: 'Audio',
};
